import { MenuItem } from "@mui/material";
import { colorPrimary } from "@/constants/colors";
import { Hint } from "@/HOC";
import { TCustomMenuItemProps } from "./CustomMenuItem.props";

const CustomMenuItem = ({ hint = "", hintPosition, ...props }: TCustomMenuItemProps): JSX.Element => {
	return (
		<Hint hint={hint} position={hintPosition} width="100%">
			<MenuItem
				{...props}
				sx={{
					color: colorPrimary,
					fontFamily: "inherit",
					fontSize: 13,
					fontStyle: "inherit",
					fontWeight: "inherit",
					lineHeight: "inherit",
					letterSpacing: "inherit",
					textAlign: "left",
					...props.sx,
				}}
			/>
		</Hint>
	);
};

export default CustomMenuItem;
